function HomePage(): JSX.Element {
  return <></>;
}

export default HomePage;
